import { useReducer, useEffect } from 'react';
import axios from 'axios';
import swal from 'sweetalert2';
import { postSubmitForm } from '../../../helpers/backend_helper';
import showNotification from '../../../helpers/show_notificaton';
import preloader from '../../../helpers/Loader';

const initialState = {
  bookingId: "",
  customerDetails: [],
  packageDetails: [],
  startTime: "",
  endTime: "",
  totalPrice: 0,
  originalTotalPrice: 0,
  gameDetails: [],
  gameTotalPrice: 0,
  itemDetails: [],
  itemTotalPrice: 0,
  totalGameTime: null,
  paidByWallet: 0,
  isWalletEligible: false,
  availableBalance: "",
  discountPercentage: 0,
  postdiscountAmount: 0,
  discountInput: "",
  discountTracker: false,
  remarks: "",
  remainingPaidAmount: 0,
  changeAmount: 0,
  isBillsplit: false,
  billSplitBetween: 0,
  billSplitAmount: 0,
  differenceAmount: 0,
  paymentMethods: [],
  selectedPaymentMethods: [],
  formFieldValues: {},
  paymentDetails: [],
  branchDetails: {},
  is_personDisappear: false,
  isNoChange: false,
  is_Refund: false,
  refundAmount: 0,
  refundRemarks: "",
  refundType: "",
  finalChange: 0,
  splitCustomers: [],
  customers: [],
  addCustomerModal: false,
  isVipDiscountApplied: false,
  vipsDiscount: 0,
  isSubmitting: false,
};

function checkoutReducer(state, action) {
  switch (action.type) {
    case 'SET_STATE':
      return { ...state, ...action.payload };
    default:
      return state;
  }
}

export const useCheckout = (booking, onSuccess) => {
  const [state, dispatch] = useReducer(checkoutReducer, initialState);

  const setState = (payload) => dispatch({ type: 'SET_STATE', payload });

  useEffect(() => {
    if (booking) {
      initializeState(booking);
    }
  }, [booking]);

  useEffect(() => {
    if (state.customerDetails.length > 0) {
      fetchPaymentMethods();
      fetchCustomers();
    }
  }, [state.customerDetails]);

  const fetchCustomers = async (searchQuery = '') => {
    try {
      if(searchQuery=="")return
      const response = await axios.post(
        process.env.REACT_APP_BASEURL + "customers/getall_for_booking",
        { search_query: searchQuery },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("userToken")}`,
          },
        }
      );
      if (response.data.status === 1) {
        
        setState({ customers: response.data.data });
        return response.data.data;
      }
    } catch (error) {
      console.error("Error fetching customers:", error);
    }
  };

  const initializeState = (row) => {
    const customerDetailsObj = {
      name: row.customer_details.name,
      customer_type: row.customer_details.customer_type,
      mobile: row.customer_details.mobile,
      is_wallet_eligible: row.customer_details.is_wallet_eligible,
      wallet: row.customer_details.wallet,
      _id: row.customer_details._id,
    };

    const branchDetailObj = {
      address: row.branch_details?.address,
      branch_id: row.branch_details?.branch_id,
      email: row.branch_details?.email,
      mobile: row.branch_details?.mobile,
      name: row.branch_details?.name,
    };

    const formattedPackageDetails = row.package_details.map(pkg => {
      const formattedItems = pkg.item_details.map(item => ({
        available: {
          in_unit: item.available.in_unit,
          in_sub_unit: item.available.in_sub_unit,
        },
        category: item.category,
        cost_price: item.cost_price,
        formula: item.formula,
        is_household_item: item.is_household_item,
        image_url: item.image_url,
        item_id: item.item_id,
        name: item.name,
        quantity: {
          in_unit: item.quantity.in_unit,
          in_sub_unit: item.quantity.in_sub_unit,
        },
        new_available: {
          in_unit: item.new_available.in_unit,
          in_sub_unit: item.new_available.in_sub_unit,
        },
        section: item.section,
        selling_price: item.selling_price,
        threshold: item.threshold,
        unit: item.unit,
        sub_unit: item.sub_unit,
      }));

      const formattedGames = pkg.game_details.map(game => ({
        description: game.description,
        image: game.image,
        table_id: game.table_id,
        game_id: game.game_id,
        name: game.name,
        table_number: game.table_number,
        table_start_time: game.table_start_time,
        table_end_time: game.table_end_time,
        duration: game.duration,
        requested_duration: game.requested_duration,
        new_duration: game.new_duration,
        price: game.price,
      }));

      return {
        package_id: pkg.package_id,
        package_name: pkg.package_name,
        item_details: formattedItems,
        game_details: formattedGames,
      };
    });

    const formattedGameDetails = row.game_details?.map(gameDetail => ({
      capacity: gameDetail.capacity,
      game: {
        name: gameDetail.game.name,
        price_for_friend: gameDetail.game.price_for_friend,
        price_for_regular: gameDetail.game.price_for_regular,
        price_for_vip: gameDetail.game.price_for_vip,
        sub_total: gameDetail.game.sub_total,
        duration: gameDetail.game.duration,
        table_start_time: gameDetail.game.table_start_time,
        table_end_time: gameDetail.game.table_end_time,
        available: gameDetail.game.available,
        description: gameDetail.game.description,
        game_id: gameDetail.game.game_id,
        image: gameDetail.game.image,
      },
      is_active: gameDetail.is_active,
      is_occupied: gameDetail.is_occupied,
      label: gameDetail.label,
      table_number: gameDetail.table_number,
      table_type: gameDetail.table_type,
      value: gameDetail.value,
      _id: gameDetail._id,
    }));

    const formattedItemDetails = row.item_details?.map(itemDetail => ({
      available: {
        in_unit: itemDetail?.available.in_unit,
        in_sub_unit: itemDetail?.available.in_sub_unit,
      },
      category: itemDetail?.category,
      formula: itemDetail?.formula,
      image: itemDetail?.image,
      is_household_item: itemDetail?.is_household_item,
      item_id: itemDetail?.item_id,
      name: itemDetail.name,
      new_available: {
        in_unit: itemDetail.new_available.in_unit,
        in_sub_unit: itemDetail.new_available.in_sub_unit,
      },
      price: itemDetail.price,
      quantity: {
        in_unit: itemDetail.quantity.in_unit,
        in_sub_unit: itemDetail.quantity.in_sub_unit,
      },
      sub_total: itemDetail.sub_total,
      section: itemDetail.section,
      threshold: itemDetail.threshold,
      unit: itemDetail.unit,
      sub_unit: itemDetail.sub_unit,
    }));

    const totalGameTime = formattedGameDetails.reduce(
      (total, game) => total + game.game.duration,
      0
    );

    const isVip = row.customer_details?.customer_type === "VIP";
    let totalPrice = Math.round(row.game_total_price) + Math.round(row.item_total_price)
    setState({
      bookingId: row._id,
      remarks: row.remarks,
      customerDetails: [customerDetailsObj],
      branchDetails: branchDetailObj,
      packageDetails: formattedPackageDetails,
      gameDetails: formattedGameDetails,
      itemDetails: formattedItemDetails,
      totalGameTime,
      gameTotalPrice: Math.round(row.game_total_price),
      itemTotalPrice: Math.round(row.item_total_price) || 0,
      startTime: row.start_time,
      endTime: row.end_time,
      totalPrice: isVip && !state.isBillsplit ? 0 : totalPrice,
      remainingPaidAmount: isVip && !state.isBillsplit ? 0 : totalPrice,
      originalTotalPrice: totalPrice,
      availableBalance: row.customer_details.wallet,
      isWalletEligible: row.customer_details.is_wallet_eligible,
      discountInput: "",
      discountPercentage: 0,
      postdiscountAmount: 0,
      discountTracker: false,
      selectedPaymentMethods: [],
      formFieldValues: {},
      isBillsplit: false,
      billSplitAmount: 0,
      billSplitBetween: 0,
      differenceAmount: 0,
      paymentDetails: [],
      changeAmount: 0,
      finalChange: 0,
      is_personDisappear: false,
      isVipDiscountApplied: isVip && !state.isBillsplit ? true : false,
    });
  };

  const fetchPaymentMethods = async () => {
    try {
      const response = await axios.post(
        process.env.REACT_APP_BASEURL + "payment_methods/getall",
        {},
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("userToken")}`,
          },
        }
      );

      if (response.data.status === 1) {
        const active = response.data.data.filter(e => e.is_active === true);
        active.sort((a, b) => a.name.localeCompare(b.name));
        setState({ paymentMethods: active });
      }
    } catch (error) {
      console.error("Error fetching payment methods:", error);
    }
  };
  
  const handleValidSubmit = (e, v) => {
    try {
  let payload;
    setState({isSubmitting:true})
  
    if (state.isBillsplit) {
      
      const split_details = state.splitCustomers.map(split => {
        const totalPaidByCustomer = split.paymentMethods.reduce((sum, pm) => sum + (pm.amount || 0),0);
        const IsVIP =  split.customer?.customer_type === 'VIP'
        const amountPerPerson = state.billSplitAmount;
        const effectiveAmountToPay =  amountPerPerson;
        const change = split.isNoChange? 0: totalPaidByCustomer - effectiveAmountToPay;
        const due_amount = change < 0 ? Math.abs(change) : 0;

        const payment_details_for_split = split.paymentMethods.map(pm => ({
          _id: pm.value,
          [pm.label]: pm.amount || 0,
        }));

        return {
          customer_details: split.customer,
          amount_to_pay: amountPerPerson, 
          paid_amount: totalPaidByCustomer,
          change_amount: !split.isNoChange && change > 0 ? change : 0,
          difference_amount: split.isNoChange ? totalPaidByCustomer - effectiveAmountToPay : 0,
          due_amount: due_amount, 
          payment_details: payment_details_for_split,
        };
      });

      payload = {
        remarks: state.remarks,
        customer_details: state.customerDetails[0],
        booking_id: state.bookingId,
        branch_details: state.branchDetails,
        
        game_details: state.gameDetails,
        item_details: state.itemDetails,
        package_details: state.packageDetails,

        item_total_price: state.itemTotalPrice,
        game_total_price: state.gameTotalPrice,
        total_time: state.totalGameTime,

        total_amount: state.itemTotalPrice + state.gameTotalPrice,

        discount: state.discountPercentage,
        discount_amount: +state.postdiscountAmount || 0,
        vip_discount: +state.vipsDiscount,

        paid_amount: totalPaidByAllSplitCustomers,
        final_amount: +state.totalPrice - state.vipsDiscount,

        change_amount: totalChangeByAllSplitCustomers > 0 ? totalChangeByAllSplitCustomers : 0,
        difference_amount: totalDifferenceByAllSplitCustomers > 0 ? totalDifferenceByAllSplitCustomers : 0,
        
        is_bill_split: true,
        split_details: {
          split_between: +state.billSplitBetween,
          amount_per_person: +state.billSplitAmount,
          splits: split_details,
        },
      };
    } else {
      payload = {
        remarks: state.remarks,
        customer_details: state.customerDetails[0],
        booking_id: state.bookingId,
        branch_details: state.branchDetails,

        game_details: state.gameDetails,
        item_details: state.itemDetails,
        package_details: state.packageDetails,

        item_total_price: state.itemTotalPrice,
        game_total_price: state.gameTotalPrice,
        total_time: state.totalGameTime,

        total_amount: state.itemTotalPrice + state.gameTotalPrice,

        discount: state.discountPercentage,
        discount_amount: +state.postdiscountAmount || 0,
        vip_discount: state.isVipDiscountApplied ? +state.originalTotalPrice : 0,

        paid_amount: totalPaidAmount,
        final_amount: +state.totalPrice,
        
        change_amount: !state.isNoChange && state.finalChange > 0 ? state.finalChange : 0,
        difference_amount: state.isNoChange ? state.finalChange : 0 ,

        payment_details: state.paymentDetails,
        is_bill_split: false,
      };
    }

    let total = Math.round(state.itemTotalPrice + state.gameTotalPrice - state.postdiscountAmount);
    let extraFromSplit = state.billSplitAmount * state.billSplitBetween - total;
    // console.log(total,"total");
    // console.log(extraFromSplit,"extraFromSplit");
    
    if (state.isBillsplit) {
      if (extraFromSplit > 0){
         payload.extra_amount = extraFromSplit;
        payload.split_details.extra_amount = extraFromSplit;
       } else{
         payload.split_details.extra_amount = 0;
         payload.extra_amount = 0;
       } 
    }
    // console.log(payload,"payload");
    // return;
    
    let url = process.env.REACT_APP_BASEURL;
    axios
      .post(url + `sales/check_out`, payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("userToken")}`,
        },
      })
      .then(response => {
        if (response.data.status === 1) {
          showNotification(response.data.message, "Success");
          onSuccess();
          const invoiceData = response.data.data;
          const invoiceUrl =
            `${window.location.origin}/invoice_details?booking_id=` +
            invoiceData?.booking_id;
          const newTab = window.open(`${invoiceUrl}`, "_blank");
          if (newTab) {
            newTab.focus();
          }
        } else {
          showNotification(response.data.message, "error");
        }
      })
      .catch(error => {
        console.error("Error:", error);
        if (error.response) {
          showNotification(error.response.data.message, "error");
        } else {
          showNotification("An error occurred while check-out.", "error");
        }
      });
} catch (error) {
  console.log(error);
} finally {
  setState({isSubmitting:false})
}
  };

  const handleValidSubmitUnpaid = (e, v) => {
    const payload = {
      remarks: state.remarks || "",
      customer_details: state.customerDetails[0],
      booking_id: state.bookingId,
      branch_details: state.branchDetails,
      game_details: state.gameDetails,
      item_details: state.itemDetails,
      package_details: state.packageDetails,
      payment_details: state.paymentDetails,
      item_total_price: state.itemTotalPrice,
      game_total_price: state.gameTotalPrice,
      total_amount: state.itemTotalPrice + state.gameTotalPrice,
      total_time: state.totalGameTime,
    };

    let url = process.env.REACT_APP_BASEURL;

    axios
      .post(url + `sales/checkout_unpaid`, payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("userToken")}`,
        },
      })
      .then(response => {
        if (response.data.status === 1) {
          showNotification(response.data.message, "Success");
          onSuccess();
        } else {
          showNotification(response.data.message, "error");
        }
      })
      .catch(error => {
        console.error("Error:", error);
        if (error.response) {
          showNotification(error.response.data.message, "error");
        } else {
          showNotification("An error occurred while check-out.", "error");
        }
      });
  };

  const applyDiscount = async () => {
    if (!state.discountInput || typeof state.discountInput !== "string") {
      swal.fire({
        title: "Invalid Coupon Code",
        text: "Please enter a valid coupon code.",
        icon: "error",
      });
      return;
    }

    try {
      const response = await axios.post(
        process.env.REACT_APP_BASEURL + "coupons/getall",
        {},
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("userToken")}`,
          },
        }
      );

      if (response.data.status === 1) {
        const enteredCoupon = response.data.data.find(
          coupon =>
            coupon.coupon_code === state.discountInput && coupon.is_active === true
        );

        if (enteredCoupon) {
          const couponDiscount = enteredCoupon.discount_percent;
          const discountedTotal = state.originalTotalPrice * (1 - couponDiscount / 100);
          const discountAmount = (state.originalTotalPrice - discountedTotal).toFixed(2);

          const newState = {
            discountPercentage: couponDiscount,
            postdiscountAmount: +discountAmount,
            totalPrice: Math.round(discountedTotal),
            remainingPaidAmount: Math.round(discountedTotal),
            discountTracker: true,
          };

          if (state.isBillsplit) {
            const splitBetween = state.billSplitBetween;
            if (splitBetween > 0) {
                const newSplitAmount = Math.ceil(newState.totalPrice / splitBetween);
                const withoutCeilSplit = newState.totalPrice / splitBetween;
                const newDifference = ((newSplitAmount - withoutCeilSplit) * splitBetween).toFixed(2);
                const newTotalPriceForSplit = newState.totalPrice + parseFloat(newDifference);

                const newSplits = state.splitCustomers.map(split => ({
                    ...split,
                    paidAmount: split.customer?.customer_type === "VIP" ? 0 : newSplitAmount,
                }));

                const vipsDiscount = newSplits.reduce((acc, split) => {
                    return acc + (split.customer?.customer_type === "VIP" ? newSplitAmount : 0);
                }, 0);

                newState.totalPrice = newTotalPriceForSplit;
                newState.billSplitAmount = newSplitAmount;
                newState.differenceAmount = +newDifference;
                newState.splitCustomers = newSplits;
                newState.vipsDiscount = vipsDiscount;
            }
          }

          setState(newState);

          swal.fire({
            title: "Coupon Applied",
            text: `Coupon "${state.discountInput}" applied successfully for ${couponDiscount}% discount.`,
            icon: "success",
          });
        } else {
          swal.fire({
            title: "Coupon Not Found",
            text: `Coupon "${state.discountInput}" is not valid.`,
            icon: "error",
          });
        }
      } else {
        showNotification(response.data.message, "error");
      }
    } catch (error) {
      if (error.response) {
        showNotification(error.response.data.message, "error");
      } else {
        swal.fire(
          "Error",
          "An error occurred while applying the coupons.",
          "error"
        );
      }
    }
  };

  const handleDurationChange = (e, rowIndex, row, editorProps) => {
    const { value } = e.target;
    editorProps.onUpdate(+value);

    let price = 0;
    if (state.customerDetails[0]?.customer_type === "Friend") {
      price = row.game.price_for_friend;
    } else if (state.customerDetails[0]?.customer_type === "Regular") {
      price = row.game.price_for_regular;
    } else if (state.customerDetails[0]?.customer_type === "VIP") {
      price = 0;
    }

    let a = [...state.gameDetails];
    let initialSubTotal;
    a.forEach(e => {
      if (e._id === row._id) {
        initialSubTotal = e.game.sub_total;
        if (row.game.name.includes("VIP")) {
          if (+value > 60) {
            let sixtyMin = 60;
            let rem = +value - sixtyMin;
            e.game.sub_total = (150 / 60) * sixtyMin + (100 / 60) * rem;
            e.game.sub_total = +e.game.sub_total.toFixed(2);
          } else {
            e.game.sub_total = (150 / 60) * +value;
            e.game.sub_total = +e.game.sub_total.toFixed(2);
          }
        } else {
          if (+value < 30) {
            e.game.sub_total = (price / 60) * 30;
          } else {
            e.game.sub_total = (price / 60) * +value;
            e.game.sub_total = +e.game.sub_total.toFixed(2);
          }
        }
      }
    });

    const priceDifference = a.find(e => e._id === row._id).game.sub_total - initialSubTotal;
    setState({ 
      gameDetails: a,
      totalPrice: state.totalPrice + priceDifference,
      remainingPaidAmount: state.remainingPaidAmount + priceDifference,
      totalGameTime: a.reduce((total, game) => total + game.game.duration, 0),
      gameTotalPrice: a.reduce((total, game) => total + game.game.sub_total, 0),
    });
  };

  const handleSplitBill = () => {
    const isMainCustomerVip = state.customerDetails[0]?.customer_type === "VIP";
    const newIsBillsplit = !state.isBillsplit;
  
    if (newIsBillsplit) {
      const defaultSplitBetween = 2;
      const splitAmount = Math.ceil(state.originalTotalPrice / defaultSplitBetween);
      const withoutCeilSplit = state.originalTotalPrice / defaultSplitBetween;
      const difference = ((splitAmount - withoutCeilSplit) * defaultSplitBetween).toFixed(2);
      const newTotalPrice = state.originalTotalPrice + parseFloat(difference);

      const newSplits = Array.from({ length: defaultSplitBetween }).map((_, i) => {
        const customer = i === 0 ? state.customerDetails[0] : null;
        return {
            id: i + 1,
            customer: customer,
            paymentMethods: [],
            paymentDetails: {},
            paidAmount: customer?.customer_type === "VIP" ? 0 : splitAmount,
            changeAmount: 0,
            isNoChange: false,
        }
      });

      const calculatedVipsDiscount = newSplits.reduce((acc, split) => acc + (split.customer?.customer_type === "VIP" ? splitAmount : 0), 0);

      setState({
        isBillsplit: newIsBillsplit,
        isVipDiscountApplied: false,
        totalPrice: newTotalPrice,
        remainingPaidAmount: newTotalPrice - calculatedVipsDiscount,
        postdiscountAmount: 0,
        discountPercentage: 0,
        discountTracker: false,
        selectedPaymentMethods:[],
        paymentDetails:[],
        vipsDiscount: calculatedVipsDiscount,
        splitCustomers: newSplits,
        billSplitBetween: defaultSplitBetween,
        billSplitAmount: splitAmount,
        differenceAmount: +difference,
      });
    } else { 
      setState({
        isBillsplit: newIsBillsplit,
        isVipDiscountApplied: isMainCustomerVip ? true : false,
        totalPrice: isMainCustomerVip ? 0 : state.originalTotalPrice,
        remainingPaidAmount: isMainCustomerVip ? 0 : state.originalTotalPrice,
        postdiscountAmount: 0,
        discountPercentage: 0,
        discountTracker: false,
        splitCustomers: [],
        paymentDetails:[],
        selectedPaymentMethods:[],
        billSplitAmount: 0,
        billSplitBetween: 0,
        differenceAmount: 0,
        vipsDiscount: 0,
      });
    }
  };

  const totalPaidByAllSplitCustomers = state.splitCustomers.reduce((acc, split) => {
    const totalPaidByCustomer = split.paymentMethods.reduce((sum, pm) => sum + (pm.amount || 0), 0);
    return acc + totalPaidByCustomer;
  }, 0);

  const totalChangeByAllSplitCustomers = state.splitCustomers.reduce((acc, split) => {
    if (!split.isNoChange) {
      return acc + (split.changeAmount || 0);
    }
    return acc;
  }, 0);

    const totalDifferenceByAllSplitCustomers = state.splitCustomers.reduce((acc, split) => {
    if (split.isNoChange) {
      return acc + (split.changeAmount || 0);
    }
    return acc;
  }, 0);

  

  useEffect(() => {
    if (state.isBillsplit) {
      const totalRemaining = state.splitCustomers.reduce((acc, split) => {
        const amountToPay = split.customer?.customer_type === 'VIP' ? 0 : split.paidAmount;
        const paidByCustomer = split.paymentMethods.reduce((sum, pm) => sum + (pm.amount || 0), 0);
        const remainingForSplit = amountToPay - paidByCustomer;
        return acc + remainingForSplit;
      }, 0);
      
      const vipsDiscount = state.splitCustomers?.reduce((a,c)=>a+(c.customer?.customer_type === "VIP" ? state.billSplitAmount : 0),0);

      setState({ remainingPaidAmount: totalRemaining, vipsDiscount: vipsDiscount });
    } else {
      const totalPaid = state.selectedPaymentMethods.reduce((total, paymentMethod) => {
        const fieldName = `paymentMethod_${paymentMethod.value}`;
        return total + (parseFloat(state.formFieldValues[fieldName]) || 0);
      }, 0);
      setState({ remainingPaidAmount: state.totalPrice - totalPaid - parseFloat(state.paidByWallet) });
    }
  }, [state.isBillsplit, state.splitCustomers, state.totalPrice, state.formFieldValues, state.paidByWallet, state.selectedPaymentMethods, state.billSplitAmount]);

  const handleBillSplitBetweenChange = e => {
    const value = Number(e.target.value);

    if (value < 2) {
      // showNotification("Minimum 2 people for bill split", "error");
      setState({ 
        billSplitBetween: 0, 
        differenceAmount: 0, 
        billSplitAmount: 0, 
        totalPrice: state.originalTotalPrice, 
        remainingPaidAmount: state.originalTotalPrice, 
        splitCustomers: [] 
      });
      return;
    }

    if (value > 0) {
      const splitAmount = Math.ceil(state.totalPrice / value);
      // console.log(splitAmount,"split amount");
      
      const withoutCeilSplit = state.totalPrice / value;
      const difference = ((splitAmount - withoutCeilSplit) * value).toFixed(2);
      const newTotalPrice = state.totalPrice + parseFloat(difference);
      const newSplits = Array.from({ length: value }).map((_, i) => {
        const customer = i === 0 ? state.customerDetails[0] : null;
        return {
            id: i + 1,
            customer: customer,
            paymentMethods: [],
            paymentDetails: {},
            paidAmount: customer?.customer_type === "VIP" ? 0 : splitAmount,
            changeAmount: 0,
            isNoChange: false,
        }
      });
      const calculatedVipsDiscount = newSplits.reduce((acc, split) => acc + (split.customer?.customer_type === "VIP" ? splitAmount : 0), 0);
      setState({ 
        billSplitBetween: value, 
        differenceAmount: +difference, 
        billSplitAmount: splitAmount, 
        totalPrice: newTotalPrice, 
        remainingPaidAmount: newTotalPrice - calculatedVipsDiscount,
        splitCustomers: newSplits,
        vipsDiscount: calculatedVipsDiscount
      });
    } else {
      setState({ 
        billSplitBetween: 0, 
        differenceAmount: 0, 
        billSplitAmount: 0, 
        totalPrice: state.originalTotalPrice, 
        remainingPaidAmount: state.originalTotalPrice, 
        splitCustomers: [] 
      });
    }
  };

  const handlePaymentMethodChange = selectedOptions => {
    const newPaymentDetails = selectedOptions.map(selectedOption => {
      const fieldName = `paymentMethod_${selectedOption.value}`;
      const existingDetail = state.paymentDetails.find(detail => detail._id === selectedOption.value);
      const value = existingDetail ? existingDetail[selectedOption.label] : "";
      return {
        _id: selectedOption.value,
        [selectedOption.label]: value !== "" ? value : 0,
      };
    });
    const totalPaidAmount = newPaymentDetails.reduce((total, paymentMethod) => {
      for (const key in paymentMethod) {
        if (key !== "_id") {
          total += parseFloat(paymentMethod[key]) || 0;
        }
      }
      return total;
    }, 0);
    const newRemainingPaidAmount = state.totalPrice - totalPaidAmount - parseFloat(state.paidByWallet);
    const unselectedOptions = state.selectedPaymentMethods.filter(option => !selectedOptions.includes(option));
    const newFormFieldValues = { ...state.formFieldValues };
    unselectedOptions.forEach(unselectedOption => {
      const fieldName = `paymentMethod_${unselectedOption.value}`;
      newFormFieldValues[fieldName] = "";
    });
    setState({ 
      paymentDetails: newPaymentDetails, 
      remainingPaidAmount: newRemainingPaidAmount.toFixed(2), 
      formFieldValues: newFormFieldValues, 
      selectedPaymentMethods: selectedOptions 
    });
  };

  const handlePaymentAmountChange = (selectedOption, amount) => {
    const newAmount = parseFloat(amount) || 0;
    const fieldName = `paymentMethod_${selectedOption.value}`;

    const newFormFieldValues = { ...state.formFieldValues, [fieldName]: amount };

    const newPaymentDetails = state.paymentDetails.map(detail => {
      if (detail._id === selectedOption.value) {
        return { ...detail, [selectedOption.label]: newAmount };
      }
      return detail;
    });

    const totalPaidAmount = newPaymentDetails.reduce((total, paymentMethod) => {
      for (const key in paymentMethod) {
        if (key !== "_id") {
          total += parseFloat(paymentMethod[key]) || 0;
        }
      }
      return total;
    }, 0);

    const newRemainingPaidAmount = state.totalPrice - totalPaidAmount - parseFloat(state.paidByWallet) -
                                   (state.isBillsplit ? state.vipsDiscount : (state.isVipDiscountApplied ? state.originalTotalPrice : 0));

    setState({
      formFieldValues: newFormFieldValues,
      paymentDetails: newPaymentDetails,
      remainingPaidAmount: newRemainingPaidAmount.toFixed(2),
      finalChange: newRemainingPaidAmount < 0 ? Math.abs(newRemainingPaidAmount) : 0
    });
  };

  const totalPaidAmount = state.paymentDetails.reduce((total, paymentMethod) => {
    for (const key in paymentMethod) {
      if (key !== "_id") {
        total += parseFloat(paymentMethod[key]) || 0;
      }
    }
    return total;
  }, 0);

  const handleRefundAmount = (e) => {
    let refund = +e.target.value;
    let changeAfterRefund = 0;
    if (refund > state.changeAmount) {
      changeAfterRefund = totalPaidAmount - refund;
      setState({ refundAmount: refund, finalChange: changeAfterRefund });
    } else {
      changeAfterRefund = state.changeAmount - refund;
      setState({ refundAmount: refund, finalChange: changeAfterRefund });
    }
  };

  const isCheckoutOpen = async () => {
    await axios.post(process.env.REACT_APP_BASEURL + `bookings/isCheckoutOpen`, {
      booking_id: state.bookingId,
      newValue: true
    }, {
      headers: { Authorization: `Bearer ${localStorage.getItem("userToken")}` },
    }).catch(error => console.error("Error:", error));
  };

  const isCheckoutClose = async () => {
    await axios.post(process.env.REACT_APP_BASEURL + `bookings/isCheckoutOpen`, {
      booking_id: state.bookingId,
      newValue: false
    }, {
      headers: { Authorization: `Bearer ${localStorage.getItem("userToken")}` },
    }).catch(error => console.error("Error:", error));
  };

  function handleRefundChecked(e) {
    setState({ 
      refundAmount: 0, 
      refundType: "", 
      refundRemarks: "", 
      is_Refund: e.target.checked 
    });
  }

  const CheckAmounts = () => {
    
    if (state.is_personDisappear) {
      handleValidSubmitUnpaid();
      return;
    }
    
    const isMainCustomerVip = state.customerDetails[0]?.customer_type === "VIP";

    if (isMainCustomerVip && !state.isBillsplit) {
      handleValidSubmit();
      return;
    }

    if (!state.isBillsplit) {
        if (totalPaidAmount < state.totalPrice) {
            showNotification( "Total amount does not match entered amount.", "error");
            return;
        }
    }

    if (state.isBillsplit) {
      if (!state.splitCustomers || state.splitCustomers.length === 0) {
        showNotification( "Please enter split details.", "error");
        return;
      }

      for (const split of state.splitCustomers) {
        if (!split.customer || !split.customer._id) {
          showNotification("Please ensure all split customers have details.", "error");
          return;
        }
        const totalPaidByCustomer = split?.paymentMethods.reduce((sum, pm) => sum + (pm.amount || 0), 0);
        const amountToPayForSplit = split?.customer?.customer_type === "VIP" ? 0 : state.billSplitAmount;

        if (split.customer?.customer_type !== "VIP" && !split.isNoChange && totalPaidByCustomer < amountToPayForSplit) {
          showNotification(`Payment for ${split.customer.name} is not complete.`, "warning");
          return;
        }
      }
    } else {
      if (totalPaidAmount < state.totalPrice) {
        showNotification("Total amount does not match entered amount.", "error");
        return;
      }
    }

    handleValidSubmit();
  };

    function toggle() {
    setState({ 
      addCustomerModal: false, 
    });
  }

   function handleAddCustomer(v) {
     try {
      preloader(true)
          const object = {
            name: v.name,
            mobile: v.mobile,
            customer_type: v.customer_type || "Regular",
          }
          // console.log(object);
          let url = process.env.REACT_APP_BASEURL + "customers/insert"
          postSubmitForm(url, object).then(res => {
            if (res.status === 1) {
               preloader(false)
              showNotification(res.message, "Success")
              setState({ 
                addCustomerModal: false, 
              });
            } else {
               preloader(false)
              showNotification(res.message, "Error")
            }
          })
        } catch (error) {
                preloader(false)
          showNotification(error.message, "Error")
          console.log(error)
        }
  }

  const handleEnableWallet = (customerId, index) => {
    try {
      preloader(true);
      const url = process.env.REACT_APP_BASEURL + "customers/activate_wallet";
      postSubmitForm(url, { id: customerId, is_wallet_eligible: true }).then(res => {
        if (res.status === 1) {
          preloader(false);
          showNotification(res.message, "Success");
          const updated = [...state.splitCustomers];
          updated[index].customer.is_wallet_eligible = true;
          setState({ splitCustomers: updated });
        } else {
          preloader(false);
          showNotification(res.message, "Error");
        }
      });
    } catch (error) {
      preloader(false);
      showNotification(error.message, "Error");
      console.log(error);
    }
  };

  const handleEnableWalletForCustomer = (customerId) => {
    try {
      preloader(true);
      const url = process.env.REACT_APP_BASEURL + "customers/activate_wallet";
      postSubmitForm(url, { id: customerId, is_wallet_eligible: true }).then(res => {
        if (res.status === 1) {
          preloader(false);
          showNotification(res.message, "Success");
          const updatedCustomerDetails = [...state.customerDetails];
          updatedCustomerDetails[0].is_wallet_eligible = true;
          setState({ customerDetails: updatedCustomerDetails });
          fetchPaymentMethods();
        } else {
          preloader(false);
          showNotification(res.message, "Error");
        }
      });
    } catch (error) {
      preloader(false);
      showNotification(error.message, "Error");
      console.log(error);
    }
  };

  return { ...state, setState, CheckAmounts, handleValidSubmit, 
    handleValidSubmitUnpaid, applyDiscount, handleDurationChange, handleSplitBill, 
    totalPaidByAllSplitCustomers,  handleBillSplitBetweenChange, handlePaymentMethodChange, handlePaymentAmountChange, 
    totalPaidAmount, handleRefundAmount, isCheckoutOpen, isCheckoutClose, handleRefundChecked,
    fetchCustomers,toggle,handleAddCustomer, handleEnableWallet, handleEnableWalletForCustomer };
};